module.exports = __webpack_public_path__ + "static/img/wealth_level_70.6dad84e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_70.png
// module id = gWC0
// module chunks = 0